export default __webpack_public_path__ + "static/media/ventasTotalesIcon.d083f903.svg";